import { Table } from 'antd'
import React, { Component } from 'react'
import { PricingAPI } from '../../../controller/PricingAPI';

export class RoomCategoryPage extends Component {
    state = {
        loading: false,
        details: []
    };
    componentDidMount() {
        this.refresh();
    }
    refresh = () => {
        this.setState({ loading: true });
        PricingAPI.roomcategories.index({}, 1, 999).then((response) => {
            const result = response.data;
            this.setState({ details: result.data.sort((a, b) => a.rank - b.rank) });
        }).finally(() => {
            this.setState({ loading: false });
        });
    }
    render() {
        const columns = [
            {
                title: '類型代號',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '名稱',
                dataIndex: 'name',
                key: 'name',
            },
        ];
        return (
            <div>
                <h1>房型分類</h1>
                <Table columns={columns} dataSource={this.state.details} rowKey="id" loading={this.state.loading} scroll={{ x: 'max-content' }} size="small" />
            </div>
        )
    }
}

export default RoomCategoryPage